import { render, staticRenderFns } from "./Polynesias.vue?vue&type=template&id=d656b5c4&"
import script from "./Polynesias.vue?vue&type=script&lang=js&"
export * from "./Polynesias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports